import Vue from 'vue'
import Vuex from 'vuex'
import services from './modules/services'

Vue.use(Vuex)

const state = {}

const getters = {}

const actions = {}

const mutations = {}

const store = new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	modules: {
		services: services
	}
});

export default store;
